import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CodeMirror from '@uiw/react-codemirror'
import { javascript } from '@codemirror/lang-javascript';


export type AvroProps = {
    avroCode: any
    setAvroCode: any
    getAvroCode: any

};

const AvroGenerator = (props: AvroProps) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        props.getAvroCode(props.avroCode);
        setOpen(false);
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1200,
        background: 'white',
        height: 500,
        p: 4,
    };

    const buttonStyle = {
        background: 'white',
        width: 1200,
        ml: -4,
        p: 2,
    };

    return (
        <>
            <Button id="b070769b-3949-4079-b2e4-2123ad2e0028"
                color="primary"
                variant="contained"
                onClick={handleOpen}
                sx={{ m: 1 }}
            >
                Import fields from AVRO schema
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                        <h2>Create AVRO Schema</h2>
                        <p>Note: When creating your data extractor, please ensure that a single data type is used in your AVRO file to prevent data issues when extracting into the Unity Data Lake</p>
                        <CodeMirror
                            value={props.avroCode}
                            height="300px"
                            extensions={[javascript({ jsx: true })]}
                            onChange={(value, viewUpdate) => {
                                props.setAvroCode(value);
                            }}
                        />
                        <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                            <Button id="14e57c17-92e5-4c55-b270-2d02c22f5cf0" color="primary" variant="contained" onClick={handleClose}>Generate Schema</Button>
                        </Box>
                    </Typography>
                </Box>
            </Modal>
        </>

    )

};

export default AvroGenerator;